import {assertPartialSchema, createAction, useSelector, v, _} from '../../../lib'

export enum LoadingActionType {
  LOADING_SET = 'LOADING_SET',
  LOADING_DELETE = 'LOADING_DELETE',
  LOADING_RESET = 'LOADING_RESET',
}

export const doLOADING_SET = createAction(LoadingActionType.LOADING_SET)
export const doLOADING_DELETE = createAction(LoadingActionType.LOADING_DELETE)
export const doLOADING_RESET = createAction(LoadingActionType.LOADING_RESET)

export interface LoadingState {
  requestId: string
  type?: string
}

export const LOADING_TIMEOUT_MS = 60 * 1000

interface RootState {
  loading: Record<string, LoadingState>
}

export const selectLoading = () => {
  return useSelector((state: RootState) => state.loading)
}

export const loadingActionCreators = {
  doLOADING_SET,
  doLOADING_DELETE,
  doLOADING_RESET,
}

export const loadingDefaultState: RootState['loading'] = {}

type Action =
  | {
      type: LoadingActionType.LOADING_SET
      payload: {
        requestId: string
        type?: string
      }
    }
  | {
      type: LoadingActionType.LOADING_DELETE
      payload: {
        requestId: string
      }
    }
  | {
      type: LoadingActionType.LOADING_RESET
      payload: never
    }

export const loadingReducer = (state: RootState['loading'] = {}, {type, payload}: Action) => {
  switch (type) {
    case LoadingActionType.LOADING_SET: {
      assertPartialSchema({
        payload,
        schema: v.object({
          requestId: v.string().uuid().optional(),
          type: v.string().optional(),
        }),
      })
      const {requestId} = payload
      if (!requestId || requestId in state) return state
      return {
        ...state,
        [requestId]: payload,
      }
    }
    case LoadingActionType.LOADING_DELETE: {
      assertPartialSchema({
        payload,
        schema: v.object({
          requestId: v.string().uuid().optional(),
        }),
      })
      const {requestId} = payload
      if (!requestId) return state
      const newState = {...state}
      delete newState[requestId]
      return newState
    }
    case LoadingActionType.LOADING_RESET:
      return {}
    default:
      return state
  }
}
